import React from 'react';
import { getCountries } from '../utils/countryUtils';
export function CountrySelector({
  value,
  onChange,
  locale
}) {
  const countries = getCountries();
  // Sort countries based on locale if needed
  const sortedCountries = [...countries].sort((a, b) => {
    // If the user's locale matches a country, put it first
    if (locale.startsWith(a.code.toLowerCase())) return -1;
    if (locale.startsWith(b.code.toLowerCase())) return 1;
    return a.name.localeCompare(b.name, locale);
  });
  return <select value={value} onChange={e => onChange(e.target.value)} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" required data-id="element-15695">
      <option value="" data-id="element-15696">Select a country</option>
      {sortedCountries.map(country => <option key={country.code} value={country.code} data-id="element-15697">
          {country.name}
        </option>)}
    </select>;
}